
import React, { useState ,useContext } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";
import NavContext from "../Context/NavContext";
const SubMenu=(props)=> {
    // const [item, setItem] = useState(props.item);
  const [subnav, setSubnav] = useState(false);
  // const [navData,setNavData]=useState(props.navData);
  const showSubnav = () => setSubnav(!subnav);
  const { setSidebar } = useContext(NavContext);
  return (
    <React.Fragment>
      {
        <ul>
        <li
          key={props.indexValue}
          className={props.item.cName}
          id="visible"
          onClick={props.item.submenu && showSubnav}
        >
          <Link
            to={props.item.path}
            style={{ display: "flex", gap: "10px", alignItems: "center" }}
          >
            <div style={{ display: "flex", gap: "23px", width: "200px" }}>
              {" "}
              {props.item.icon}
              <span>{props.item.title}</span>
            </div>

            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {props.item.submenu && subnav
                ? props.item.iconOpened
                : props.item.submenu
                ? props.item.iconClosed
                : null}
            </div>
          </Link>

          <ul key={props.indexValue} className="nav-menu-items ulbg" >
            {subnav &&
              props.item.submenu.map((type, index) => {
                if (props.navData[type.permission]) {
                  return (
                    <li key={index} className={type.cName}  >
                      <Link to={type.path} onClick={()=>setSidebar(false)}>
                        {type.icon}
                        <span >{type.title}</span>
                      </Link>{" "}
                    </li>
                  );
                }
              })}
          </ul>
        </li>
        </ul>
      }
    </React.Fragment>
  );
}

export default SubMenu;